// Backend sentinel for an explicitly selected All filter. Never a fallback company ID.
export const defaultAllSelection = 99999;
